// extracted by mini-css-extract-plugin
export default {"container":"SponsoredView_container__xmLyV"};